// extracted by mini-css-extract-plugin
export default {"headerWrapper":"style_headerWrapper__qrwm-","title":"style_title__udqOv"};